export default __webpack_public_path__ + "static/media/waiting-room.0ee74d95.jpg";